export const DATATYPE_COLUMN_WIDTH = {
  date: 120,
  datetime: 150,
  default: 200,
  popup: 200
}; // excel(*.xls)

export const EXCLE_XLS = 'application/vnd.ms-excel'; // excel(*.xlsx)

export const EXCLE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const STATION = {
  PURCHASE: 'purchase',
  SALE: 'sale'
};
export const DIALOG_TABLE_MAX_HEIGHT = 600;